export default __webpack_public_path__ + "static/media/Lynx_Logo_Final.66db6604.jpeg";